
export class AdjudicationDO {
    public levelCd: any = null
    public approvedClaimAmt: any = null
    public adjDecisionCd: any = null
    public remarks: any = null
}